// src/pages/PublishDestinations.jsx
import React from "react";
import { useParams, useNavigate } from "react-router-dom";

const networks = [
  { key: "facebook",  name: "Facebook Page" },
  { key: "instagram", name: "Instagram" },
  { key: "x",         name: "X (Twitter)" },
  { key: "linkedin",  name: "LinkedIn Page" },
];

export default function PublishDestinations() {
  const { id } = useParams();
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto p-6">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Publish post</h1>
        <button className="text-slate-600 hover:text-slate-900" onClick={() => navigate(-1)}>Close</button>
      </div>

      <p className="text-slate-600 mb-6">
        Connect a social account below, then you’ll be able to publish this post directly from Clikke. (Post ID: {id})
      </p>

      <div className="grid sm:grid-cols-2 gap-4">
        {networks.map(n => (
          <div key={n.key} className="border border-slate-200 rounded-xl p-4 flex items-center justify-between">
            <div className="font-medium">{n.name}</div>
            <button className="rounded-lg bg-sky-600 text-white px-4 py-2 hover:bg-sky-700"
              onClick={() => alert(`TODO: OAuth connect flow for ${n.name}`)}>
              Connect
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
